<template>
  <div class="back-button-wrapper">
    <Button
      icon="pi pi-arrow-left"
      label="Zurück zur Startseite"
      @click="router.push({ name: RouteNames.HOME })"
      class="back-button"
    />
  </div>
</template>

<script setup lang="ts">
  import { useRouter } from "vue-router";
  import { RouteNames } from "@/router/RouteNames";
  import Button from "primevue/button";

  const router = useRouter();
</script>

<style scoped>
  .back-button-wrapper {
    width: 95vw;
    display: flex;
    justify-content: flex-start;
  }

  .back-button {
    display: flex;
    align-items: center;
  }
</style>
